<template>
  <div class="new-message-panel">
    <div class="new-message-panel__header">
      <div class="text-h6 font-weight-bold">New Message</div>
      <div class="text-medium-emphasis">
        Choose from the list of available
        {{ isProvider ? "students" : "providers" }}.
      </div>
    </div>

    <div
      v-if="targets.length === 0"
      class="text-center text-medium-emphasis pa-6"
    >
      No one to message yet.
    </div>

    <v-list v-else class="new-message-panel__rows">
      <v-list-item
        v-for="target in targets"
        :key="targetKey(target)"
        class="new-message-panel__row"
        @click="select(target)"
      >
        <div class="new-message-panel__row-content">
          <v-avatar
            v-if="target.otherUser.photoUrl"
            :image="target.otherUser.photoUrl"
            size="50"
          ></v-avatar>
          <v-avatar v-else color="primary" size="50">
            {{ initials(target.otherUser.name) }}
          </v-avatar>

          <div class="new-message-panel__row-body">
            <div class="font-weight-bold text-body-2">
              {{ target.otherUser.name }}
            </div>
            <v-chip size="x-small" variant="outlined" class="product-chip">{{
              productLabel(target)
            }}</v-chip>
          </div>

          <div class="new-message-panel__row-action text-medium-emphasis">
            {{
              target.existingConversationToken
                ? "Open conversation"
                : "New conversation"
            }}
          </div>
        </div>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import useInboxState from "@/composables/useInboxState";

const inbox = useInboxState();

export default {
  name: "NewMessagePanel",
  data() {
    return { inbox };
  },
  computed: {
    targets() {
      return this.inbox.state.eligibleTargets;
    },
    isProvider() {
      return !!this.$store.state.user?.provider;
    }
  },
  methods: {
    targetKey(target) {
      return `${target.otherUser.id}-${target.product}-${target.basicNeedsCase
        ?.id ?? "none"}`;
    },
    productLabel(target) {
      if (target.product !== "uthrive") return "Therapy";
      return target.basicNeedsCase
        ? `Basic Needs (BN${target.basicNeedsCase.id})`
        : "Basic Needs";
    },
    initials(name) {
      return (name || "")
        .split(" ")
        .map(part => part[0])
        .join("")
        .slice(0, 2)
        .toUpperCase();
    },
    select(target) {
      this.inbox.openConversation({
        conversationToken: target.existingConversationToken,
        recipientId: target.otherUser.id,
        product: target.product,
        basicNeedsCaseId: target.basicNeedsCase?.id
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@use "../../styles/base/variables" as *;

.new-message-panel__header {
  padding: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.new-message-panel__row {
  cursor: pointer;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.new-message-panel__row-content {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 8px 0;
}

.new-message-panel__row-body {
  flex: 1;
  min-width: 0;
}

.new-message-panel__row-action {
  font-size: 13px;
  flex-shrink: 0;
}

.product-chip {
  border-color: $uwill-peri !important;
  color: $uwill-peri !important;
  min-height: auto;
}
</style>
